import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectBriefAnswersParams } from '@/shared/api/end-points/project'
import { ProjectBriefAnswer } from '../../lib'

const getProjectBriefAnswers = async (params: GetProjectBriefAnswersParams) => {
  return await api.json<ProjectBriefAnswer[]>(API_END_POINTS.project.getProjectBriefAnswers(params))
}

export default getProjectBriefAnswers
